import { Adventure, useSyncAdventureStatus } from '~/components/Adventure/Adventure.hooks';
import { EndedAdventureHero } from '~/components/Adventure/Hero/Ended/EndedAdventureHero';
import { InProgressAdventureHero } from '~/components/Adventure/Hero/InProgress/InProgressAdventureHero';
import { UpcomingAdventureHero } from '~/components/Adventure/Hero/Upcoming/UpcomingAdventureHero';

export type AdventureHeroProps = Pick<Adventure, 'id'> & { className?: string };

const adventureHeroMap = {
  UPCOMING: UpcomingAdventureHero,
  IN_PROGRESS: InProgressAdventureHero,
  END: EndedAdventureHero,
};

export const AdventureHero = ({ id, ...props }: AdventureHeroProps) => {
  const status = useSyncAdventureStatus(id);
  const Component = adventureHeroMap[status || 'IN_PROGRESS'];

  return <Component id={id} {...props} />;
};
